'use client'

import {observer} from 'mobx-react'
import {usePathname, useRouter, useSearchParams} from 'next/navigation'

import React, {useEffect} from 'react'

import {Routes} from '@/src/config/routes'
import {AsyncProcessLoading} from '@/src/shared/ui/layout/ui/async-loading'
import {useQueryClient} from '@tanstack/react-query'
import {useStore} from '@/src/shared/hooks/useStore'

export const AuthProtect = observer(({children}: React.PropsWithChildren) => {
  const queryClient = useQueryClient()
  const store = useStore()
  const path = usePathname()
  const router = useRouter()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!store.session?.user?.id) {
      const redirectPath = `${Routes.auth.login.page}?${new URLSearchParams({
        next: `${path}${new URLSearchParams(searchParams).toString()}`,
      }).toString()}`

      queryClient.invalidateQueries()
      router.push(redirectPath)
    }
  }, [])

  if (!store.session?.user?.id) return <AsyncProcessLoading />
  return children
})
